import { CircularProgress, Dialog, DialogContent, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";


export const RTFOLoadingPadData = ({ setIsInitialLoad, darkMode }) => {
  const theme = useTheme();

  return (
    <Dialog 
      open={true} 
      fullWidth={true}
      maxWidth="sm"
      style={{overflow: 'hidden'}}
      PaperProps={{
        style: {
          backgroundColor: theme?.palette?.paper?.[darkMode ? 'dark' : 'light']
        }
      }}
      onClose={() => setIsInitialLoad && setIsInitialLoad(false)}
    >
      <DialogContent style={{minHeight: 400, overflow: 'hidden'}}>
        
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: 400, overflow: 'hidden'}}>
          <Typography style={{marginBottom: 20}}>Loading pad data, please wait...</Typography>
          <CircularProgress style={{color: darkMode ? 'white' : theme.palette.primary.main}} ></CircularProgress>
        </div>

      </DialogContent>
    </Dialog>
  );
};